import _defineProperty from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { BackgroundImage, Tooltip } from '@mantine/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './WarzoneLeaderboardCharacterPanel.styles.js';
import { FactionIdToName } from '../utils.js';
import { Crown } from '../../logos/leaderboards/Crown.js';
import { FactionLogo } from '../../logos/factions/FactionLogo.js';
var WarzoneLeaderboardStatsIndexFromGroup = function WarzoneLeaderboardStatsIndexFromGroup(group) {
  return group.slice(0, 1).toLowerCase() + group.slice(1);
};
var useCharacterStats = function useCharacterStats(_ref) {
  var character = _ref.character,
    statsGroup = _ref.statsGroup;
  return useMemo(function () {
    var statIndex = WarzoneLeaderboardStatsIndexFromGroup(statsGroup);
    return {
      points: character.victoryPoints[statIndex],
      kills: character.kills[statIndex]
    };
  }, [character, statsGroup]);
};
var PlaceholderTooltip = function PlaceholderTooltip(_ref2) {
  var children = _ref2.children;
  return /* @__PURE__ */jsx(Fragment, {
    children: children
  });
};
var WarzoneLeaderboardCharacterPanel = function WarzoneLeaderboardCharacterPanel(_ref3) {
  var _cx;
  var className = _ref3.className,
    classNames = _ref3.classNames,
    styles = _ref3.styles,
    unstyled = _ref3.unstyled,
    character = _ref3.character,
    focusStat = _ref3.focusStat,
    _ref3$statsGroup = _ref3.statsGroup,
    statsGroup = _ref3$statsGroup === void 0 ? "LastWeek" : _ref3$statsGroup,
    _ref3$imageServerUrl = _ref3.imageServerUrl,
    imageServerUrl = _ref3$imageServerUrl === void 0 ? "https://images.evetech.net" : _ref3$imageServerUrl,
    _ref3$factionTheme = _ref3.factionTheme,
    factionTheme = _ref3$factionTheme === void 0 ? "noFaction" : _ref3$factionTheme,
    _ref3$rank = _ref3.rank,
    rank = _ref3$rank === void 0 ? 0 : _ref3$rank,
    _ref3$showCrown = _ref3.showCrown,
    showCrown = _ref3$showCrown === void 0 ? true : _ref3$showCrown,
    _ref3$showRank = _ref3.showRank,
    showRank = _ref3$showRank === void 0 ? true : _ref3$showRank,
    _ref3$showEnlisted = _ref3.showEnlisted,
    showEnlisted = _ref3$showEnlisted === void 0 ? false : _ref3$showEnlisted,
    _ref3$showTooltips = _ref3.showTooltips,
    showTooltips = _ref3$showTooltips === void 0 ? true : _ref3$showTooltips,
    _ref3$hideRankIfNotEn = _ref3.hideRankIfNotEnlisted,
    hideRankIfNotEnlisted = _ref3$hideRankIfNotEn === void 0 ? false : _ref3$hideRankIfNotEn,
    _ref3$colorEnlisted = _ref3.colorEnlisted,
    colorEnlisted = _ref3$colorEnlisted === void 0 ? false : _ref3$colorEnlisted,
    _ref3$cutOffLogos = _ref3.cutOffLogos,
    cutOffLogos = _ref3$cutOffLogos === void 0 ? false : _ref3$cutOffLogos;
  var _a, _b, _c;
  var _useStyles = useStyles(void 0, {
      name: "WarzoneLeaderboardCharacterPanel",
      classNames: classNames,
      styles: styles,
      unstyled: unstyled
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var stats = useCharacterStats({
    character: character,
    statsGroup: statsGroup
  });
  var characterPortraitUrl = "".concat(imageServerUrl, "/characters/").concat(character.id, "/portrait?size=256");
  var allianceUrl = "".concat(imageServerUrl, "/alliances/").concat((_a = character.alliance) == null ? void 0 : _a.id, "/logo?size=32");
  var corporationUrl = "".concat(imageServerUrl, "/corporations/").concat((_b = character.corporation) == null ? void 0 : _b.id, "/logo?size=32");
  var topSpot = rank === 1;
  var TooltipComponent = showTooltips ? Tooltip : PlaceholderTooltip;
  var factionClassName = classes[factionTheme];
  var topSpotNoFaction = topSpot && factionTheme === "noFaction";
  var factionName = character.faction && character.faction.id && FactionIdToName(character.faction.id);
  return /* @__PURE__ */jsxs("div", {
    className: cx(className, classes.root, factionClassName),
    children: [/* @__PURE__ */jsxs(BackgroundImage, {
      src: characterPortraitUrl,
      className: classes.portrait,
      children: [rank !== 0 && /* @__PURE__ */jsxs("div", {
        className: cx(classes.rank, (_cx = {}, _defineProperty(_cx, classes.topSpot, topSpot), _defineProperty(_cx, classes.topNoFaction, topSpotNoFaction), _cx)),
        children: [topSpot && showCrown && /* @__PURE__ */jsx("div", {
          className: classes.crown,
          children: /* @__PURE__ */jsx(Crown, {})
        }), rank && rank]
      }), /* @__PURE__ */jsxs("div", {
        className: classes.bottom,
        children: [showEnlisted && factionName && /* @__PURE__ */jsx("div", {
          className: cx(classes.bottomImageWrapper, _defineProperty({}, classes.bottomImageWithCutoff, cutOffLogos)),
          children: /* @__PURE__ */jsx(TooltipComponent, {
            label: t("warzone.faction.".concat(factionName)),
            children: /* @__PURE__ */jsx(FactionLogo, {
              faction: factionName,
              size: 22,
              fillColor: colorEnlisted ? void 0 : "white"
            })
          })
        }), character.alliance && /* @__PURE__ */jsx("div", {
          className: cx(classes.bottomImageWrapper, _defineProperty({}, classes.bottomImageWithCutoff, cutOffLogos)),
          children: /* @__PURE__ */jsx(TooltipComponent, {
            label: character.alliance.name,
            children: /* @__PURE__ */jsx("img", {
              src: allianceUrl
            })
          })
        }), character.corporation && /* @__PURE__ */jsx("div", {
          className: cx(classes.bottomImageWrapper, _defineProperty({}, classes.bottomImageWithCutoff, cutOffLogos)),
          children: /* @__PURE__ */jsx(TooltipComponent, {
            label: character.corporation.name,
            children: /* @__PURE__ */jsx("img", {
              src: corporationUrl
            })
          })
        })]
      })]
    }), /* @__PURE__ */jsxs("div", {
      className: classes.content,
      children: [/* @__PURE__ */jsx("h3", {
        children: character.name
      }), /* @__PURE__ */jsxs("div", {
        className: classes.stats,
        children: [showRank && (!hideRankIfNotEnlisted || character.enlisted) && /* @__PURE__ */jsxs("div", {
          className: cx(classes.statsInner, _defineProperty({}, classes.focusStat, focusStat === "rank")),
          children: [/* @__PURE__ */jsxs("span", {
            children: [t("warzone.leaderboard.rank"), ":"]
          }), /* @__PURE__ */jsx("span", {
            children: character.enlisted ? t("warzone.ranks.".concat(factionName, ".").concat((_c = character.currentRank) != null ? _c : 0)) : t("warzone.notEnlisted")
          })]
        }), /* @__PURE__ */jsxs("div", {
          className: cx(classes.statsInner, _defineProperty({}, classes.focusStat, focusStat === "points")),
          children: [/* @__PURE__ */jsxs("span", {
            children: [t("warzone.leaderboard.points"), ":"]
          }), /* @__PURE__ */jsx("span", {
            children: t("fmt.number", {
              value: stats.points
            })
          })]
        }), /* @__PURE__ */jsxs("div", {
          className: cx(classes.statsInner, _defineProperty({}, classes.focusStat, focusStat === "kills")),
          children: [/* @__PURE__ */jsxs("span", {
            children: [t("warzone.leaderboard.kills"), ":"]
          }), /* @__PURE__ */jsx("span", {
            children: t("fmt.number", {
              value: stats.kills
            })
          })]
        })]
      })]
    })]
  });
};
export { WarzoneLeaderboardCharacterPanel };